"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.WithMediaQueriesType = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));
var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));
var _themeMapper = require("@gravity/theme-mapper");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _withWindowSize = _interopRequireDefault(require("./withWindowSize"));
var _excluded = ["windowSize"];
var _jsxFileName = "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/Utils/lib/withMediaQueries.js",
  _this = void 0;
function cov_z48e1hyrf() {
  var path = "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/Utils/lib/withMediaQueries.js";
  var hash = "94c175b6872e43555563042d1908ecc81c37d6e5";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/Utils/lib/withMediaQueries.js",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 28
        },
        end: {
          line: 6,
          column: 91
        }
      },
      "1": {
        start: {
          line: 6,
          column: 85
        },
        end: {
          line: 6,
          column: 90
        }
      },
      "2": {
        start: {
          line: 14,
          column: 24
        },
        end: {
          line: 19,
          column: 2
        }
      },
      "3": {
        start: {
          line: 14,
          column: 80
        },
        end: {
          line: 19,
          column: 1
        }
      },
      "4": {
        start: {
          line: 27,
          column: 25
        },
        end: {
          line: 27,
          column: 217
        }
      },
      "5": {
        start: {
          line: 27,
          column: 83
        },
        end: {
          line: 27,
          column: 217
        }
      },
      "6": {
        start: {
          line: 27,
          column: 128
        },
        end: {
          line: 27,
          column: 216
        }
      },
      "7": {
        start: {
          line: 29,
          column: 36
        },
        end: {
          line: 34,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 75
          },
          end: {
            line: 6,
            column: 76
          }
        },
        loc: {
          start: {
            line: 6,
            column: 85
          },
          end: {
            line: 6,
            column: 90
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 14,
            column: 24
          },
          end: {
            line: 14,
            column: 25
          }
        },
        loc: {
          start: {
            line: 14,
            column: 80
          },
          end: {
            line: 19,
            column: 1
          }
        },
        line: 14
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 27,
            column: 25
          },
          end: {
            line: 27,
            column: 26
          }
        },
        loc: {
          start: {
            line: 27,
            column: 83
          },
          end: {
            line: 27,
            column: 217
          }
        },
        line: 27
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 27,
            column: 98
          },
          end: {
            line: 27,
            column: 99
          }
        },
        loc: {
          start: {
            line: 27,
            column: 128
          },
          end: {
            line: 27,
            column: 216
          }
        },
        line: 27
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 14,
            column: 36
          },
          end: {
            line: 14,
            column: 74
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 14,
            column: 55
          },
          end: {
            line: 14,
            column: 74
          }
        }],
        line: 14
      },
      "1": {
        loc: {
          start: {
            line: 27,
            column: 45
          },
          end: {
            line: 27,
            column: 78
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 27,
            column: 59
          },
          end: {
            line: 27,
            column: 78
          }
        }],
        line: 27
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0],
      "1": [0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "94c175b6872e43555563042d1908ecc81c37d6e5"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_z48e1hyrf = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_z48e1hyrf();
var DEFAULT_BREAKPOINTS = (cov_z48e1hyrf().s[0]++, (0, _values.default)(_themeMapper.evolutionTheme.breakpoints).sort(function (a, b) {
  cov_z48e1hyrf().f[0]++;
  cov_z48e1hyrf().s[1]++;
  return a - b;
}));

/**
 * Media query based on the window size and array of breakpoints.
 * @param {Object} screenSize - Destructured object containing the window width.
 * @param {number[]} breakpoints - Array of breakpoint sizes.
 * @returns {Object} Object indicating active breakpoints.
 */
cov_z48e1hyrf().s[2]++;
var getMediaQueries = function getMediaQueries(_ref) {
  var width = _ref.width;
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_z48e1hyrf().b[0][0]++, DEFAULT_BREAKPOINTS),
    _ref3 = (0, _slicedToArray2.default)(_ref2, 4),
    sm = _ref3[0],
    md = _ref3[1],
    lg = _ref3[2],
    xl = _ref3[3];
  cov_z48e1hyrf().f[1]++;
  cov_z48e1hyrf().s[3]++;
  return {
    sm: width >= sm,
    md: width >= md,
    lg: width >= lg,
    xl: width >= xl
  };
};

/**
 * Enhances a component with screen query information based on window size and breakpoints.
 * @param {React.Component} EnhancedComponent - The component to enhance.
 * @param {number[]} breakpoints - Array of breakpoint sizes.
 * @returns {React.Component} Enhanced component with screen query information.
 */
cov_z48e1hyrf().s[4]++;
var withMediaQueries = function withMediaQueries(EnhancedComponent) {
  var breakpoints = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_z48e1hyrf().b[1][0]++, DEFAULT_BREAKPOINTS);
  cov_z48e1hyrf().f[2]++;
  cov_z48e1hyrf().s[5]++;
  return (0, _withWindowSize.default)(function (_ref4) {
    var windowSize = _ref4.windowSize,
      props = (0, _objectWithoutProperties2.default)(_ref4, _excluded);
    cov_z48e1hyrf().f[3]++;
    cov_z48e1hyrf().s[6]++;
    return /*#__PURE__*/_react.default.createElement(EnhancedComponent, (0, _extends2.default)({}, props, {
      mediaQueries: getMediaQueries(windowSize, breakpoints),
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 27,
        columnNumber: 129
      }
    }));
  });
};
var WithMediaQueriesType = exports.WithMediaQueriesType = (cov_z48e1hyrf().s[7]++, _propTypes.default.shape({
  sm: _propTypes.default.bool,
  md: _propTypes.default.bool,
  lg: _propTypes.default.bool,
  xl: _propTypes.default.bool
}));
var _default = exports.default = withMediaQueries;